import { render } from "./Section.vue?vue&type=template&id=126c4534&scoped=true&ts=true"
import script from "./Section.vue?vue&type=script&lang=ts"
export * from "./Section.vue?vue&type=script&lang=ts"

import "./Section.vue?vue&type=style&index=0&id=126c4534&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126c4534"]])

export default __exports__